<template>
  <div class="custom-control custom-switch">
    <input
      type="checkbox"
      class="custom-control-input"
      v-bind:value="value"
      v-bind:true-value="trueValue"
      v-bind:false-value="falseValue"
      v-model="model"
      v-on="listeners"
      v-bind="$attrs"
    />
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'WCSwitch',
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    value: {
      default: true,
    },
    checked: {},
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
  },
  computed: {
    listeners() {
      const { change, ...listeners } = this.$listeners;
      return listeners;
    },
    model: {
      get() {
        return this.checked;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.custom-control {
  user-select: none;
}
</style>
